<template>
  <md-menu-item @click="$emit('toggleAll')">
    <md-checkbox class="md-primary" />
    <!-- eslint-disable-next-line -->
    <span v-if="showSelectAll" class="md-list-item-text">- Select all -</span>
    <span v-else class="md-list-item-text">- Unselect all -</span>
  </md-menu-item>
</template>

<script>
export default {
  name: 'ToggleAllOptionComponent',
  props: {
    value: Array,
    types: [Array, Boolean],
  },
  computed: {
    showSelectAll() {
      return this.value?.length < this.types?.length
    },
  },
}
</script>
